
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Pourquoi miser sur le contenu Evergreen pour booster votre SEO",
    description:
      "Le contenu Evergreen génère un trafic stable sur le long terme. Découvrez comment l'intégrer à votre SEO pour des résultats durables. Suivez les conseils d'ALEO !",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
